import React from "react";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import "../Styles/_DataConflictWindow.css";

const DataConflictWindow = ({ open, handleSubmit, heading, subheading, yesText }) => {
    return (
        <Dialog
            className="popup-simple-window-dialog"
            classes={{ paper: "popup-simple-window-dialog-paper" }}
            disableBackdropClick
            disableEscapeKeyDown
            open={open || false}
        >
            <div id="popup-simple-window" className={`layout vertical popup-simple-window cancel-order-window relative`}>
                <div className="popup-window-inner">
                    <div className="layout vertical header">
                        <p className="layout vertical center-center title">
                            <p className="title">{heading}</p>
                        </p>
                    </div>
                    <div className="layout vertical body">
                        <p className="layout vertical center-center sub-title">{subheading}</p>
                    </div>
                    <div className="layout vertical footer">
                        <div className="layout vertical buttons-box">
                            <div className="flex layout dynamic-direction-mobile-portrait buttons">
                                <button className="flex custom-button" onClick={handleSubmit}>
                                    <div className="layout vertical center-center inbutton-text">{yesText}</div>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default withRouter(DataConflictWindow);
